import  { instance  } from "../api";


const fetchTypeService = (setServiceAttributes) => {
   
      instance.get("/api/service/")
      .then((result)=>  { 
        setServiceAttributes(result.data)
      
      
     })                  
    .catch ((error) =>{console.log('error', error)
      
    })
};

export default fetchTypeService;
export const contacterService= async(ServiceId, formData)=>{
  try 
  { 
    const response = await instance.post(`/api/service/${ServiceId}/formulaire/information`, formData);
   
     return response
 }
  catch(error ) {
     throw new Error(`Erreur lors de l'envoi : ${error.response?.status || error.message}`);
   };
  
 }